





































/** デコレータ利用のためComponent, Vueをimport **/
import { Component, Vue } from 'vue-property-decorator';
/** 画面で必要なVuexの各stateをimport **/
import hexabaseState from '@/store/hexabase';
import searchState from '@/store/search';
import userState from '@/store/user';
/** 画面で利用するバックエンド設定のimport **/
import {
  DatastoreFields,
  FieldChildrenProp,
  GetItemSearchRes,
  GetItemsResponse
} from '@/services/hexabase/types';
/** 画面で利用するモデルファイルをimport **/
import InformationModel from '@/models/informationModel';
import { searchFormInformationList } from '@/constants/form/informationForm';
import {
  SearchPanelColumnWidth,
  InformationListDefine,
  InformationMasterDeleteStatusExcludeSearch,
  InformationDefaultSort
} from '@/constants/information/information';
import { listPerPage } from '@/constants/util';

/** 画面で利用するコンポーネントをimport 下部に存在する＠Componentにも記載する **/
import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import SearchPanel from '@/components/common/modules/list/SearchPanel.vue';
import SearchList from '@/components/common/modules/list/SearchList.vue';

@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    SearchPanel,
    SearchList
  }
})

/* eslint-disable @typescript-eslint/camelcase */
export default class InformationList extends Vue {
  // モデルをセット
  readonly basicModel = new InformationModel();
  // アプリIDをセット
  readonly applicationId = hexabaseState.applicationId;
  // dbID格納プロパティ
  readonly mainDsId = hexabaseState.datastoreIds['お知らせ情報マスタ'];

  // マスタデータ関連格納プロパティ
  masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};

  // アイテム取得時Param
  payload = {
    conditions: [] as Array<{ [key: string]: string | string[] | boolean }>,
    per_page: listPerPage,
    page: 1,
    use_display_id: true,
    include_links: true,
    include_lookups: true,
    sort_fields: InformationDefaultSort
  };
  // 各入力フィールド情報格納プロパティ
  searchFieldsData: Array<FieldChildrenProp> = [];
  searchFieldCols = '';
  statusList: Array<GetItemSearchRes> = [];

  // 一覧表示部分に使用
  fieldsData: DatastoreFields = {
    field_layout: {},
    fields: {}
  };
  apiResponseData: GetItemsResponse = { items: [], totalItems: 0 };
  apiResult = false;
  colums: Array<{ [k: string]: string | number }> = [];
  buttonItems = InformationListDefine.buttonItems;

  // ページネーション情報
  page = {
    currentPage: 1,
    totalPage: 1,
    totalItem: 0,
    visible: 8,
    perPage: listPerPage
  };

  // 検索結果コンポーネント用プロパティ
  isFlush = false;

  // 検索文言
  dataTableText = InformationListDefine.message.dataTableText;

  async created() {
    try {
      // ローディングをセット
      hexabaseState.setIsLoading(true);

      // 管理者権限判定
      if (!userState.isAdmin) {
        this.setError(this.basicModel.getDefaultRoleErrorMessage());
        return;
      }
      // データストア情報セット
      const [fieldsData, statusList] = await Promise.all([
        this.basicModel.getField(this.applicationId, this.mainDsId),
        this.basicModel.getStatusList(this.applicationId, this.mainDsId)
      ]);
      // 自動生成コンポーネント用にプロパティー設定
      this.fieldsData = fieldsData;
      this.searchFieldsData = this.basicModel.createSearchConf(
        this.fieldsData,
        this.masterData,
        searchFormInformationList
      );

      this.searchFieldCols = `${SearchPanelColumnWidth}% `.repeat(100 / SearchPanelColumnWidth); //検索フォームは表示を均等にするため固定

      // 初期表示データ取得・作成
      // 検索Stateが存在していたら検索項目に値をセットする
      const stateCondition =
        searchState.searchCondition !== undefined ? searchState.searchCondition : [];
      for (const key in stateCondition) {
        const setConditionIndex = this.searchFieldsData.findIndex(
          field => field.display_id === stateCondition[key].id
        );
        if (setConditionIndex >= 0) {
          const dataType = this.searchFieldsData[setConditionIndex].dataType;
          switch (dataType) {
            case 'dslookup':
              this.searchFieldsData[setConditionIndex].props!.value = {
                item_id: stateCondition[key].search_value[0]
              };
              break;
            case 'status':
              this.searchFieldsData[setConditionIndex].props!.value =
                stateCondition[key].search_value[0];
              break;
            case 'datetime':
              this.searchFieldsData[setConditionIndex].props!.valueFrom =
                stateCondition[key].search_value[0];
              this.searchFieldsData[setConditionIndex].props!.valueTo =
                stateCondition[key].search_value[1];
              break;
            default:
              this.searchFieldsData[setConditionIndex].props!.value =
                stateCondition[key].search_value[0];
              break;
          }
        }
      }

      // 一覧カラム設定
      // Hexabase側でDBフィールドとは別に自動的に保持している「作成日時」「更新日時」を表示するため、
      // baseModelのcreateColumnsメソッドは使用しない
      this.colums = InformationListDefine.tableColumns;
    } catch (e) {
      this.setError(e as string | object);
    } finally {
      hexabaseState.setIsLoading(false);
    }
  }

  /**
   * 一覧表示するアイテムを取得する
   * @param {array} condition - 検索条件を指定する
   * @param {number} page - 検索オフセット情報
   * @returns {void} 各内部プロパティに情報セット
   */
  async getItems(condition?: Array<{ [key: string]: string[] }>, page?: number) {
    if (condition !== undefined && condition.length > 0) {
      for (const key in searchState.searchCondition) {
        const findData = condition.find(
          recode => recode.id === searchState.searchCondition![key].id
        );
        if (!findData) {
          condition.push(searchState.searchCondition[key]);
        } else {
          const setConditionIndex = this.searchFieldsData.findIndex(
            field => field.display_id === searchState.searchCondition[key].id
          );
          if (setConditionIndex >= 0) {
            const componentType = this.searchFieldsData[setConditionIndex].component;
            switch (componentType) {
              case 'DatePickerRangeArea':
                if (searchState.searchCondition[key].search_value[0] && !findData.search_value[0]) {
                  findData.search_value[0] = searchState.searchCondition[key].search_value[0];
                }
                if (searchState.searchCondition[key].search_value[1] && !findData.search_value[1]) {
                  findData.search_value[1] = searchState.searchCondition[key].search_value[1];
                }
                break;
              default:
                break;
            }
          }
        }
      }
      searchState.setConditions(condition);
    }
    this.apiResult = false;
    if (condition !== undefined) {
      // conditionsに固定条件を付与するためconcatで参照渡しを回避する
      this.payload['conditions'] = condition.concat();
    }

    // アイテムのStatusが削除済は検索対象に含めない条件を追加
    this.payload.conditions.push(InformationMasterDeleteStatusExcludeSearch);

    this.payload['page'] = page !== undefined ? page : 1;

    try {
      // ローディングをセット
      hexabaseState.setIsLoading(true);
      this.apiResponseData = await this.basicModel.getItemSearch(
        this.applicationId,
        this.mainDsId,
        this.payload
      );

      if (this.apiResponseData.errors !== undefined) {
        this.dataTableText = this.basicModel.getErrMessage('ITEMLIST', this.apiResponseData);
      } else if (this.apiResponseData.items.length === 0) {
        this.dataTableText = this.basicModel.getMessage('ITEMLIST', 'NOT_FOUND');
      }
    } catch (e) {
      this.setError(e as string | object);
    } finally {
      hexabaseState.setIsLoading(false);
      this.apiResult = true;
    }

    // 一覧に表示される日付項目の書式設定
    for (const index in this.apiResponseData.items) {
      const item = this.apiResponseData.items[index];
      item.publication_start_date = this.basicModel.editDatetype(
        item.publication_start_date,
        'Asia/Tokyo',
        'yyyy/MM/dd'
      );
      item.publication_end_date = this.basicModel.editDatetype(
        item.publication_end_date,
        'Asia/Tokyo',
        'yyyy/MM/dd'
      );
      item.registration_date = this.basicModel.editDatetype(
        item.registration_date,
        'Asia/Tokyo',
        'yyyy/MM/dd H:mm:ss'
      );
      item.registration_date = this.basicModel.editDatetype(
        item.registration_date,
        'Asia/Tokyo',
        'yyyy/MM/dd H:mm:ss'
      );
      item.created_at = this.basicModel.editDatetype(
        item.created_at,
        'Asia/Tokyo',
        'yyyy/MM/dd H:mm:ss'
      );
      item.updated_at = this.basicModel.editDatetype(
        item.updated_at,
        'Asia/Tokyo',
        'yyyy/MM/dd H:mm:ss'
      );
    }

    // アイテム数等をセット
    this.page.totalItem = this.apiResponseData.totalItems;
    this.page.totalPage = this.basicModel.getTotalPage(
      this.apiResponseData.totalItems,
      listPerPage
    );
    this.page.currentPage = this.payload['page'];
  }

  /**
   * 検索パネルにて「リセット」ボタン押下時
   * 内部プロパティの検索情報を消去する
   * @returns void 内部プロパティ消去
   */
  resetSearchForm(): void {
    this.payload.conditions.splice(0);
    this.payload.page = 1;
  }

  /**
   * ページネーションボタンが押下された際
   * 指定ページの情報を問い合わせに行く
   * @param {number} response - 子コンポーネントから渡ってきたページ番号
   * @returns void API問い合わせ
   */
  pageNaviAction(response: number) {
    this.getItems(undefined, response);
  }

  /**
   * 検索結果、ボタン押下時の各処理を記載
   * @param response - クリックしたボタンタイプ、インデックス、レコード情報
   * @return void - 内部プロパティ変更
   */
  clickButton(response: { [k: string]: any }) {
    switch (response.buttonName) {
      case 'detail': {
        // お知らせ情報詳細画面に遷移
        this.$router.push({
          name: 'InformationEdit',
          params: { id: response.record.i_id },
          query: { searchConditions: 'true' }
        });
        break;
      }
    }
  }

  /**
   * API実行結果から受け取ったエラーメッセージを共通のエラーダイアログに表示する
   * @param errorMessage {string | object } - API実行結果から受け取ったエラーメッセージ
   * @returns {void}
   */
  setError(errorMessage: string | object): void {
    if (typeof errorMessage === 'object') errorMessage = this.basicModel.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }
}
